import { render, staticRenderFns } from "./StatusCard.vue?vue&type=template&id=31189567&scoped=true&"
import script from "./StatusCard.vue?vue&type=script&lang=js&"
export * from "./StatusCard.vue?vue&type=script&lang=js&"
import style0 from "./StatusCard.vue?vue&type=style&index=0&id=31189567&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31189567",
  null
  
)

export default component.exports